export default "__VITE_ASSET__DJwdFUq0__"